import { render, staticRenderFns } from "./TimerQuiz.vue?vue&type=template&id=c5cc2af2&scoped=true"
import script from "./TimerQuiz.vue?vue&type=script&lang=js"
export * from "./TimerQuiz.vue?vue&type=script&lang=js"
import style0 from "./TimerQuiz.vue?vue&type=style&index=0&id=c5cc2af2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5cc2af2",
  null
  
)

export default component.exports